import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isNotNull',
  standalone: true,
})
export class IsNotNullPipe implements PipeTransform {
  transform<T>(value: T | null | undefined): boolean {
    return value !== null && value !== undefined;
  }
}
